import React from 'react'
import { Route, Switch } from 'react-router'
import { ConnectedRouter } from 'connected-react-router'
import { history } from '../redux/store'

import CobaltLayout from '../containers/layout/CobaltLayout'
import CallbackPage from '../containers/CallbackPage'
import SilentCallback from './SilentCallback'
import ProtectedRoute from '../containers/ProtectedRoute'

const Routes: React.FC = () => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/callback.html">
          <CallbackPage />
        </Route>
        <Route path="/silent.html">
          <SilentCallback />
        </Route>
        <ProtectedRoute path="/" component={CobaltLayout} />
      </Switch>
    </ConnectedRouter>
  )
}

export default Routes
